import React from 'react';
import PropTypes from 'prop-types';
import { customFieldDisplayRows, renderCustomFieldRowValue } from '../utils/customFieldHelpers';

function CrmCustomFieldsCard({
  teamId = null,
  customFieldDefinitions = [],
  customFieldValues = [],
}) {
  const rows = customFieldDisplayRows(customFieldDefinitions, customFieldValues);

  if (rows.length === 0) return null;

  return (
    <div className="cdp-card">
      <h2 className="cdp-card-title">Custom Fields</h2>
      <div className="row">
        {rows.map((row) => (
          <div className="col-md-6 mb-3" key={row.definition.id}>
            <div className="cdp-field-label">{row.definition.name}</div>
            <div className="cdp-field-value crm-custom-field-value">{renderCustomFieldRowValue(row, teamId)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

CrmCustomFieldsCard.propTypes = {
  teamId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  customFieldDefinitions: PropTypes.array,
  customFieldValues: PropTypes.array,
};

export default CrmCustomFieldsCard;
